import * as React from 'react';

import { createIcon } from '../Icon';
export const ArrowDownRightIcon = createIcon(
  <React.Fragment>
    <line x1={7} x2={17} y1={7} y2={17} />
    <polyline points="17 7 17 17 7 17" />
  </React.Fragment>,
  'ArrowDownRightIcon'
);
